import $ from "jquery";
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import init from '../AccessControl/Check';


import DatePickerV2 from "../../../components/Date/DatePicker-v2";
import DatePickerRange from "../../../components/Date/DatePickerRange";
import moment from "moment";
import PostLoginGetApi from "../../../components/Api/PostLoginGetApi";
import { CSVLink } from "react-csv";
import Popup from "../../../components/Popup";
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';
import { toast } from "react-toastify";
import number_format from "./../../../components/Constants/NumberFormat"; 
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";

const ClearanceHistory = () => {

    const companyProfile = useContext(UserBasicInfoQRContext);

    var setDatePicker = () => {
        $("#date-div").hide();
        $("#date-range-div").hide();
    
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
    
    
        var v = $("#date-range-data").val();
        if (v === "custom") {
            $("#date-range-div").show();
        }
        else if (v === "all") {
            $("#date-div").attr("style", "display:flex");
        }
    }

    const [orderList, setOrderList] = useState([]);
    const [summary, setSummary] = useState({});
    const [isFilter, setIsFilter] = useState(false);
    const [reqParam, setReqParam] = useState({
        page: 1
    })


    const filterClick = () => {

        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const [apiData, setApiData] = useState({});

    useEffect(() => {
        // Get All Orders List
        PostLoginGetApi("settlement/logs", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setOrderList(responseData["data"]["list"]);
                    setSummary(responseData["data"]["summary"]);

                    setExcelData([]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })

    }, [isFilter, reqParam]);


    const [excelData, setExcelData] = useState([]);
    const excelPrepare = () => {
        let i = 0;
        let arr  = [];
        arr[i++] = ['','CLEARANCE HISTORY REPORT'];
        arr[i++] = ['','DOWNLOAD AT', moment().format('DD MMM, YYYY hh:mm A')];
        arr[i++] = [];
        arr[i++] = ['','SETTLEMENT TYPE', companyProfile?.settlement_type];
        arr[i++] = [];
        arr[i++] = ['','FILTER BY'];
        arr[i++] = ['','DATES', 'FROM', reqParam.from ?? "-", 'TO', reqParam.end ?? "-"];
        arr[i++] = ['','SERVICE TYPES', reqParam.service_type ?? "ALL"];
        arr[i++] = ['','SEARCH BY TRANSACTION ID', reqParam.code ?? "N/A"];

        
        // Get All Orders List
        PostLoginGetApi("settlement/logs-all", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {
                    // let sum = {'qty' : 0, 'payable' : 0, 'commission' : 0, 'net' : 0};
                    let data = responseData["data"]["list"] ?? [];
                    let summery_log = responseData["data"]["summary"] ?? [];
                    let sum_log = responseData["data"]["sum"] ?? [];

                    arr[i++] = [];
                    arr[i++] = ['','SUMMARY / OVERALL'];
                    arr[i++] = ['','TOTAL TRANSACTION', summery_log.total ?? 0];
                    arr[i++] = ['','TOTAL TRANSACTION AMOUNT', summery_log.order_amount ?? 0];
                    arr[i++] = ['','TOTAL SETTLED AMOUNT', summery_log.total_settled_amount ?? 0];
                    arr[i++] = ['','TOTAL SETTLEMENT FEE', summery_log.fee_amount ?? 0];

                    arr[i++] = [];
                    arr[i++] = ['#', 'DATE TIME', 'BANK REF. ID', 'ORDER AMOUNT', 'SETTLEMENT FEE', 'SETTLED AMOUNT', 'REMARKS', 'SETTLEMENT DATE', 'SETTLEMENT BY'];


                    data.forEach((val)=>{
                        arr[i++] = [val.sno, moment(val.created_at).format("DD MMM, YYYY hh:mm A"), val.code, val.order_amount, val.settlement_amount, val.settled_amount, val.remarks, val.settlement_date, val.created_by];
                    });


                    arr[i] = ['', 'TOTAL', sum_log.total ?? 0, sum_log.order_amount ?? 0, sum_log.settlement_amount ?? 0, sum_log.settled_amount ?? 0 ];

                    setExcelData(arr);
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(()=>{
            return true;
        });
    }


    const filter = () => {
        
        reqParam.page = 1;
        
        reqParam.service_type = $("#service_type").val() ?? "";
        reqParam.code = $("#search-by-transaction-id").val() ?? "";

        // Date Filter
        let from = "", end = "";
        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate());
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }
        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate());
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }


        reqParam.from = from;
        reqParam.end = end;

        setReqParam({ ...reqParam });
        setIsFilter(true);
    }



    const resetFilterData = () => {

        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");


        $("#service_type").val('all')
        $("#search-by-transaction-id").val("");


        $("#date-div").hide();
        $("#date-range-div").show();


        filter();
        setIsFilter(false);
    }


    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }

    const [showOrders, setShowOrders] = useState(false);
    const [confirmedOrders, setConfirmedOrders] = useState({});
    

    const [data, setData] = useState({});
    const showOrderTab = (val) => {
        setData(val);

        const id = val?.id;
        PostLoginGetApi("settlement/order-list", {id: id}, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setConfirmedOrders(responseData["data"]);
                    setShowOrders(true);
                    return;
                }

                toast.error(responseData["messages"].toString());
            }
        }).catch((err) => {
            console.log(err);
        });
    }


    const downloadExcel = () => {
        try {

            let i = 0;
            let arr  = ['','CLEARANCE REPORT', "\r\n"];
            arr[i++] = ['','DOWNLOAD AT', `"${moment().format('DD MMM, YYYY hh:mm A')}"`, "\r\n"];
            arr[i++] = ["\r\n"];
            arr[i++] = ['','BASIC INFORMATION', "\r\n"];
            arr[i++] = ['','COMPANY NAME', companyProfile?.name, "\r\n"];
            arr[i++] = ['','SETTLEMENT DATE', `"${moment(data?.settlement_date).format('DD MMM, YYYY')}"`, "\r\n"];
            arr[i++] = ['','REFERENCE ID', `"${data?.code}"`, "\r\n"];
            arr[i++] = ['','TRANSFER FROM', `"${data?.bank?.name}"`, "\r\n"];
            arr[i++] = ['','TRANSFER TO', `"${data?.transfer_to}"`, "\r\n"];
            arr[i++] = ['','REMARKS', `"${data?.remarks}"`, "\r\n"];
            arr[i++] = ['','SETTLEMENT TYPE', `"${companyProfile?.settlement_type}"`, "\r\n"];
            arr[i++] = ['','SETTLED BY', `"${data?.created_by}"`, "\r\n"];
            arr[i++] = ['','SETTLED DATE TIME', `"${moment(data?.created_at).format('DD MMM, YYYY hh:mm A')}"`, "\r\n"];
            arr[i++] = ['','ATTACHMENT LINK', `"${data?.attachment ?? 'N/A'}"`, "\r\n"];
            arr[i++] = ["\r\n"];


            arr[i++] = ["#", "ORDER DATE TIME", "PROCESS DATE TIME", "ORDER TRANSACTION NO", "SERVICE", "QTY", "AMOUNT (A)", "SETTLEMENT FEE (B)", "NET PRICE (A-B)", "TRADE PRICE", "SETTLEMENT TYPE", "SETTLED AMOUNT", "REMARKS","\r\n"];
            

            confirmedOrders.forEach((__val, index)=>{
                return arr[i++] = [++index, `"${moment(__val?.booked_product?.createdAt).format("DD MMM, YYYY hh:mm A")}"`, `"${moment(__val.created_at).format("DD MMM, YYYY hh:mm A")}"`, __val.booking_code, __val.service_type[0].toString().toUpperCase()+__val.service_type.toString().slice(1), __val.quantity ?? "-", `"${number_format(__val.order_amount ?? 0)}"`, `"${number_format(__val.settlement_fee ?? 0)}"`, `"${number_format(__val.payable ?? 0)}"`, `"${number_format(__val.trade_price ?? 0)}"`, `"${__val.settlement_on}"`, (__val?.settlement_on === 'trade_price' ) ? `"${number_format(__val.trade_price ?? 0)}"` : `"${number_format(__val.payable ?? 0)}"`, __val?.remarks, "\r\n"];
            })

            
            // Prepare CSV and Download
            var blob = new Blob(arr, {type: "octet/stream"});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            
            link.href = url;
            link.setAttribute(
                'download',
                `settlement-clearance_${data?.code}_${moment.now("Y-m-d")}.csv`,
            );
            
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        catch(ex) {
            toast.error("A problem occur while downloading the excel file.");
            console.log(ex);
        }
    }


    return (
        <div className="custom-container w-full font-montserrat flex">

            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-2 pt-0">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5 mb-5">Here’s your clearance history at a glance</h6>
                    </div>

                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">
                        {(excelData.length === 0) ? 
                            <button onClick={excelPrepare} className="custom-btn mr-2 text-center">Prepare CSV</button>
                        :
                            <CSVLink className="custom-btn mr-2 text-center" filename={"clearance-history-report.csv"} onClick={() => {return true;} } data={excelData}>
                                Export CSV
                            </CSVLink>
                        }

                        <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px]">Filter</Link>
                        <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                            <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                        </svg>
                    </div>
                </div>

                <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                
                    <div className="box hover-black-green w-1/4 py-5 h-auto bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Transaction
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary.total ?? 0}</h3>
                    </div>

                    {/* <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Transaction Amount
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.order_amount ?? 0}</h3>
                    </div> */}

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%]  bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Settled Amount
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.total_settled_amount ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Fee
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.fee_amount ?? 0}</h3>
                    </div>



                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-2">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className="border rounded-lg shadow overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="text-sm px-4 py-3 text-center">#</th>
                                            <th scope="col" className="text-sm px-3 py-3">Process Info</th>
                                            <th scope="col" className="text-sm px-3 py-3">Bank Ref. Info</th>
                                            <th scope="col" className="text-sm px-3 py-3 text-center">Order<br/>Amount (A)</th>
                                            <th scope="col" className="text-sm px-3 py-3 text-center">Settlement<br/>Fee (B)</th>
                                            <th scope="col" className="text-sm px-3 py-3 text-center">Settled<br/>Amount (A-B)</th>
                                            <th scope="col" className="text-sm px-3 py-3 text-center">Settlement<br/>Type</th>
                                            <th scope="col" className="text-sm px-3 py-3">Remarks</th>
                                            <th scope="col" className="text-sm px-2 py-3 text-center">Settled Date</th>
                                            <th scope="col" className="text-sm px-2 py-3">Last Update</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200 text-md'>

                                        {orderList.map((val, index)=> (
                                            
                                            (val !== null) &&
                                            <tr key={index}>
                                                <td className='py-2 text-center border-r-2 font-semibold'>{val.sno ?? ++index}</td>
                                                <td className='px-3 py-2 border-r-2'>
                                                {moment(val.created_at).format("DD MMM, YYYY hh:mm A")}<br/>
                                                {val.created_by ?? ""}
                                                </td>
                                                <td className='px-3 py-3 border-r-2'>
                                                    <Link to="#" onClick={()=>showOrderTab(val)} className='cursor-pointer text-[#0774E9]'>
                                                        {val.code ?? ""}
                                                    </Link><br/>
                                                    {val.bank?.name ?? ""}
                                                </td>
                                                <td className='px-3 py-2 border-r-2 text-center'>{val.order_amount ?? 0}</td>
                                                <td className='px-3 py-2 border-r-2 text-center'>{val.settlement_amount ?? 0}</td>
                                                <td className='px-3 py-2 border-r-2 text-center'>{val.settled_amount ?? 0}</td>
                                                <td className={`px-3 py-2 border-r-2 text-center `+ 
                                                (companyProfile?.settlement_type === "net_price"
                                                                ? "text-orange-400"
                                                                : "text-green-400")
                                                                }>{companyProfile?.settlement_type}</td>
                                                <td className='px-3 py-2 border-r-2'>{val.remarks ?? ""}</td>
                                                <td className='px-2 py-2 border-r-2 text-center'>{moment(val.settlement_date).format("DD MMM, YYYY")}</td>
                                                <td style={{textAlign: "left"}} className='px-2 py-2'>{moment(val.updated_at).format("DD MMM, YYYY hh:mm A")}</td>
                                            </tr>
                                        ))}
                                        
                                        
                                    </tbody>
                                </table>

                            </div>
                            {/* Pagination */}
                            {(apiData?.meta?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.meta?.from * 1} - ${apiData?.meta?.to * 1} out of ${apiData?.meta?.total * 1}`}
                                    </p>


                                    {(apiData?.links?.next !== null && apiData?.links?.next !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5 ml-2">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.links?.prev !== null && apiData?.links?.prev !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }

                        </div>
                    </div>
                </div>

            </div>

            {/* Process Dialog */}
            {(showOrders === true) &&
                <div>
                    <Popup is_big={1} content={
                        <div className="p-5 text-sm">
                            <div className="flex justify-between items-center pl-1">
                                <h3 className="text-base text-black font-semibold">Order lists</h3>
                                
                                <span className="py-0.5 px-4">
                                <Link to={"#"} onClick={()=>downloadExcel()} className="text-sm px-3 py-0.5 border-[#00D632] border-2 rounded font-semibold hover:bg-[#00D632] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed mr-4">Download Excel</Link>
                                
                                {(data?.attachment) && (
                                    <Link to={data?.attachment} target="_blank" rel="noopener noreferrer" className="text-sm px-3 py-0.5 border-[#00D700] border-2 rounded font-semibold hover:bg-[#00D700] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed">
                                        Download Attachment
                                    </Link>
                                )}

                                </span>


                                <CloseBtn className="cursor-pointer float-right" onClick={()=>setShowOrders(false)} />
                            </div>

                            <div className='w-full mt-3 pr-1 whitespace-break-spaces'>
                                <table className="w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">#</th>
                                            <th scope="col" className="text-xs px-2 py-2">Order Date Time</th>
                                            <th scope="col" className="text-xs px-2 py-2">Process Date Time</th>
                                            <th scope="col" className="text-xs px-2 py-2">Order Transaction No</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Service</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Qty</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Order Amount (A)</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Fee (B)</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Net Price (A-B)</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Trade Price</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-center">Settlement Type</th>
                                            <th scope="col" className="text-xs px-2 py-2 text-right">Settled ({process.env.REACT_APP_CURRENCY_SYMBOL})</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>
                                            {confirmedOrders.map((val, i) => 
                                                <tr key={i} className='text-left'>
                                                    <td className="text-xs px-2 py-2 text-center">{i+1}</td>
                                                    <td className="text-xs px-2 py-2">{moment(val?.booked_product?.createdAt).format("DD MMM, YYYY hh:mm A")}</td>
                                                    <td className="text-xs px-2 py-2">{moment(val.created_at).format("DD MMM, YYYY hh:mm A")}</td>
                                                    <td className="text-xs px-2 py-2">{val.booking_code}</td>
                                                    <td className="text-xs px-2 py-2 text-center">{val.service_type[0].toString().toUpperCase()+val.service_type.toString().slice(1)}</td>
                                                    <td className="text-sm px-2 py-2 text-center">{number_format(val.quantity ?? "-")}</td>
                                                    <td className="text-sm px-2 py-2 text-center">{number_format(val.order_amount ?? 0)}</td>
                                                    <td className="text-sm px-2 py-2 text-center">{number_format(val.settlement_fee ?? 0)}</td>
                                                    <td className="text-sm px-2 py-2 text-center">{number_format(val.payable ?? 0)}</td>
                                                    <td className="text-sm px-2 py-2 text-center">{number_format(val.trade_price ?? 0)}</td>
                                                    <td className="text-sm px-2 py-2 text-center">{val?.settlement_on ?? "-"}</td>
                                                    <td className="text-sm px-2 py-2 text-right font-bold">
                                                        {(val.settlement_on === 'trade_price') ? number_format(val?.trade_price ?? 0) : number_format(val?.payable ?? 0) }
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        }
                    />
                </div>
            }
            {/* Process Dialog End */}

            {/* Right Side */}
            <div id="filter-div" className="custom-container-right float-right w-1/5 pl-2 pb-10 pt-4 pr-1 justify-center custom-scroll-auto mb-20 no-need-without-shadow">
                <div className="relative">
                    <h6 className="text-lg px-3 font-base pb-2 pl-2" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Settlement</h6>

                    <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                        <div className="w-full float-left pt-2 mb-4">
                            <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                <option value="all">Single Date</option>
                                <option value="custom">Date Range</option>
                            </select>
                            <DatePickerV2 />
                            <DatePickerRange />
                        </div>
                    </div>
                    
                    {/* <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-1 pt-5">
                            <select id="service_type" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Service Type</option>
                                <option value="shop">Shop</option>
                                <option value="voucher">Voucher</option>
                            </select>
                        </div>
                    </div> */}

                    <div className="box-full flex w-[95.5%] h-full text-justify py-0.5 px-0.5 ml-2 mt-10 mb-6 rounded bg-[#F5F5F5]">
                        <div className="w-full h-full float-left">
                            <input type="text" id="search-by-transaction-id" name="search-by-transaction-id" autoComplete='off' className="custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" placeholder='Search by Transaction ID' />

                        </div>
                    </div>


                    <button onClick={filter} className="custom-btn w-[97%] flow-root float-left ml-2 mt-2">Filter</button>
                    {isFilter && <button onClick={resetFilterData} className="custom-btn ml-2 mt-3 flow-root w-[97%] float-left bg-black text-white border-black" style={{ color: "#FFF" }}>Reset Filter</button>}

                </div>
            </div>
        </div>
    );


};

export default ClearanceHistory;